(function () {
    angular.module('tmx-app').controller('GuarantorDetailDynamicDialogController', ['$scope', '$mdDialog', '$filter', 'dynamicFormService', 'selectedGuarantor', 'showAddButton', 'privileges', 'pageSchema', 'pageFieldMap', 'productTypeCode','ToastService', 'tmxUtility',

        function GuarantorDetailDynamicDialogController($scope, $mdDialog, $filter, dynamicFormService, selectedGuarantor, showAddButton, privileges, pageSchema, pageFieldMap, productTypeCode, ToastService, tmxUtility) {

            //#region================  Vaiables and parameters================
            $scope.productTypeCode = productTypeCode;
            $scope.showErrors = true;
            $scope.applicationStatus = 0;
            $scope.applicationData = dynamicFormService.applicationData;
            $scope.canEdit = (privileges.edit || false) && !(privileges.viewOnly || false); // Can only edit if edit rights are there and parent tab is not disabled. form is not in view only mode
            $scope.showAddButton = showAddButton;
            var peripherals = {
                mustFields: [],//fields that must be filled irresepective of state of loan app
                locals: {
                }
            }
            if(selectedGuarantor && selectedGuarantor.TmxGuarantorChecklist && selectedGuarantor.TmxGuarantorChecklist.length>0){
                selectedGuarantor.TmxGuarantorChecklist.forEach(element => {
                    if (element.MimeType=="image/png" && element.Attachment!='') {
                        element.AttachmentURL = 'data:image/jpeg;base64,' + element.Attachment;
                    }
                    else  if (element.MimeType=="application/pdf" && element.Attachment!='') {
                        element.AttachmentURL = 'data:application/pdf;base64,' + element.Attachment;
                    }
                    else  if (element.MimeType=="application/xlsx" && element.Attachment!='') {
                        element.AttachmentURL = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + element.Attachment;
                    }
                    else  if (element.MimeType=="image/tiff" && element.Attachment!='') {
                        element.AttachmentURL = 'data:image/tiff;base64,' + element.Attachment;
                    }
                    else  if (element.MimeType=="application/msword" && element.Attachment!='') {
                        element.AttachmentURL = 'data:application/msword;base64,' + element.Attachment;
                    }
                });
            }
            var jsonObject = {
                'TmxGuarantor': angular.copy(selectedGuarantor)
            };
            var objectKeys = ['TmxGuarantor'];
            var errorControl = { // To configure validation behaviour and which checks to open
                watch: true,//switch to start watching(updates dynamically)
                show: true,//switch to show errors (red red kerdy ga har jagah :3)
                enable: true,//gloabl switch to turn on and of validation checkings
                validations: {//object to operate each validation individually
                    required: true,//only for new loan app and draft loan app, required checking must be disabled
                    maxlength: true,
                    minlength: true
                }
            };

            var keysThatAreObject = ['TmxGuarantor'];
            errorControl.validations.required = false;
            //#endregion

            //#region =============== Private Functions===========================
            (function InitializeDialog() {
                pageSchema.Fields.forEach(setFieldTableName);
                pageSchema.Tabs.forEach(tab=> tab.Fields.forEach(setFieldTableName));
                //dynamicFormService.tfsManipulation(pageSchema);
                objectKeys.push(...dynamicFormService.takeOutAllChilds(jsonObject, jsonObject.TmxGuarantor, 'TmxGuarantor'));
                jsonObject['TmxGuarantor'] = [jsonObject['TmxGuarantor']];        // make root object as an array    
                $scope.tab = dynamicFormService.loadPage(pageSchema, undefined, errorControl, peripherals);
                setupFieldMap($scope.tab);
                $scope.tab.registerDependants();
                $scope.tab.read(jsonObject, $scope.tab.fieldMap);

                function setFieldTableName(field){
                    field.FieldTableName = field.FieldTableName.replace('TmxGuarantor[0]', 'TmxGuarantor');
                }
            })();
            function setGuarantorChecklist() {
                jsonObject['TmxGuarantor']['TmxGuarantorChecklist'].forEach(function (item) {
                    if (item.Attachment) {
                        item.MimeType = "";
                        if (item.Attachment.includes('data:image/jpeg;base64')) {
                            item.MimeType = "image/png";
                        }
                        else if (item.Attachment.includes('data:application/pdf;base64')) {
                            item.MimeType = "application/pdf";
                        }
                        else if (item.Attachment.includes('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64')) {
                            item.MimeType = "application/xlsx";
                        }
                        else if (item.Attachment.includes('data:image/tiff;base64')) {
                            item.MimeType = "image/tiff";
                        }
                        else if (item.Attachment.includes('data:application/msword;base64')) {
                            item.MimeType = "application/msword";
                        }
                        item.Attachment = item.Attachment.replace('data:image/jpeg;base64,', '').replace('data:application/pdf;base64,', '').replace('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,', '').replace('data:image/tiff;base64,', '').replace('data:application/msword;base64,', '');
                    }
                });
            }

            function PrepareDataForReturn() {
                $scope.tab.write(jsonObject, false);
                dynamicFormService.bindRootObjectsToChildObjects(jsonObject, objectKeys, keysThatAreObject);
                setGuarantorChecklist();
                dynamicFormService.removeEmptyObjects(jsonObject['TmxGuarantor']);
            }
            function ValidatePage() {
                $scope.tab.verify(function () { });
                $scope.showErrors = errorControl.show || false;
                return $scope.tab.isValid;
            }

            function setupFieldMap(page) {
                page.fieldMap.all = page.fieldMap.all.filter(x => x != undefined);
                if (tmxUtility.exists(pageFieldMap, 'all')) {
                    var existingFieldIds = page.fieldMap.all.map(x => x.id);
                    var allPageFields = pageFieldMap.all.filter(x => x != undefined).filter(y => !existingFieldIds.includes(y.id));
                    page.fieldMap.all.push(...allPageFields);
                }
                if (tmxUtility.exists(pageFieldMap, 'primaryKey')) {
                    Object.keys(pageFieldMap.primaryKey).forEach(key => {
                        if (!tmxUtility.exists(page.fieldMap.primaryKey[key])) {
                            page.fieldMap.primaryKey[key] = pageFieldMap.primaryKey[key];
                        }
                    });
                }

            }

            // eslint-disable-next-line no-unused-vars
            function SetFieldsErrorControl() { // Not used for now
                try {
                    $scope.tab.pageData.fields.forEach(field => field.errorControl = errorControl);
                }
                catch (e) {
                    console.error("Error in setting guarantor error control", e);
                }
            }

            //#endregion

            //#region ================ Scope functions ============================
            $scope.updateClick = function () {
                errorControl.validations.required = true;
                let validationResult = ValidatePage();
                if (!validationResult) {
                    ToastService.showCustomToast("error", $filter('translate')("FillRequiredFields"));
                    return;
                }
                PrepareDataForReturn()
                $mdDialog.hide(jsonObject['TmxGuarantor']);
            }

            $scope.addClick = function () {
                errorControl.validations.required = true;
                let validationResult = ValidatePage();
                if (!validationResult) {
                    ToastService.showCustomToast("error", $filter('translate')("FillRequiredFields"));
                    return;
                }
                PrepareDataForReturn();
                $mdDialog.hide(jsonObject['TmxGuarantor']);
            }

            $scope.cancelClick = function () {
                $mdDialog.cancel();
            }

            //#endregion

        }]);
})();
